import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
import identity from './identity'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import { HEAD_TEACHER, CLUB_TEACHER, ADMIN } from '@/constant/constant.js'

Vue.use(Router)
const dynamicStateRouters = [
  {
    path: '',
    redirect: '/teacher-management',
    meta: {
      role: [ADMIN],
    },
  },
  {
    path: '',
    redirect: '/student-list',
    meta: {
      role: [HEAD_TEACHER],
    },
  },
  {
    path: '',
    redirect: '/club-student-list',
    meta: {
      role: [CLUB_TEACHER],
    },
  },
  {
    path: '/teacher-management',
    name: 'teacherList',
    component: () => import('@/view/teacherManagement/teacherList.vue'),
    meta: {
      title: '教师列表',
      role: [ADMIN],
      index: '1-1',
    },
  },
  {
    path: '/class-management',
    name: 'classManagement',
    component: () => import('@/view/classManagement/classList.vue'),
    meta: {
      title: '班级列表',
      role: [ADMIN],
      index: '2-1',
    },
  },
  {
    path: '/student-list',
    name: 'studentList',
    component: () => import('@/view/classManagement/studentList.vue'),
    meta: {
      title: '学生列表',
      role: [ADMIN, HEAD_TEACHER],
      index: '2-2',
    },
  },
  {
    path: '/societies-management',
    name: 'societiesList',
    component: () => import('@/view/societiesManagement/societiesList.vue'),
    meta: {
      title: '社团列表',
      role: [ADMIN, CLUB_TEACHER],
      index: '3-1',
    },
  },
  {
    path: '/club-student-list',
    name: 'clubStudentList',
    component: () => import('@/view/societiesManagement/clubStudentList.vue'),
    meta: {
      title: '社团学生列表',
      role: [ADMIN, CLUB_TEACHER],
      index: '3-2',
    },
  },
  {
    path: '/club-sign-list/:id',
    name: 'clubSignList',
    component: () => import('@/view/societiesManagement/child/clubSign.vue'),
    meta: {
      title: '学生签到列表',
      role: [ADMIN, CLUB_TEACHER],
    },
  },
  {
    path: '/club-work-detail/:id',
    name: 'clubWorkDetail',
    component: () => import('@/view/societiesManagement/child/clubWorkDetail.vue'),
    meta: {
      title: '作品详情',
      role: [ADMIN, CLUB_TEACHER],
    },
  },
  {
    path: '/vacation-list/',
    name: 'vacationList',
    component: () => import('@/view/vacationManagement/vacationList.vue'),
    meta: {
      title: '假期列表',
      role: [ADMIN],
      index: '4-1',
    },
  },
]

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/login.vue'),
  },
  {
    path: '*',
    component: () => import('@/view/NotFound.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
identity.authorize(dynamicStateRouters)



// WEBPACK FOOTER //
// ./src/router/index.js